import _ from 'lodash';

const IMAGE_FITS = {
  CONTENT: 'content',
  EXPAND:  'expand',
};

IMAGE_FITS.ALL = _.values(IMAGE_FITS);

export default IMAGE_FITS;
